<template>
    <rkm-area>
        <rkm-form v-if="model && form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        label="Número do prontuário"
                        v-model="model.prontuario"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Nome"
                        v-model="model.nome"
                        uppercase
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-date-picker
                        label="Data de nascimento"
                        v-model="model.nascimento"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="handleSearch"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        color="secondary"
                        @click="handleClear"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-if="agendados && agendados.length > 0"
            :fields="fields"
            :items="agendados"
            hide-filters
            sortBy="dataConsulta"
        >
            <template v-slot:cell(dataConsulta)="{ item }">
                {{ getFormatedDate(item.dataConsulta, 'DD/MM/YYYY') }}
            </template>
            <template v-slot:cell(nome)="{ item }">
                {{ item.nome }}
                <template v-if="item.nomeSocial">
                    <b>({{ item.nomeSocial }})</b>
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    title="Imprimir"
                    color="primary"
                    @click="handlePrint(item)"
                    small
                >
                    <rkm-icon icon="print"/>
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-area>
</template>

<script>
import { error, repository, object, data, printTransportePacienteAgendar } from '@/mixins'

import { mapActions } from 'vuex'

import moment from 'moment'

export default {
    computed: {
        fields() {
            return [
                {
                    name: "dataConsulta",
                    label: "Data da consulta",
                    key: "dataConsulta",
                    sortable: true,
                },
                {
                    name: "nome",
                    label: "Nome",
                    key: "nome",
                    sortable: true,
                },
                {
                    name: "dataNascimento",
                    label: "Data de nascimento",
                    key: "dataConsulta",
                },
                {
                    name: "prontuario",
                    label: "Prontuário",
                    key: "prontuario",
                    sortable: true,
                },
                {
                    name: "municipio",
                    label: "Município",
                    key: "municipio",
                    sortable: true,
                },
                {
                    name: "destino",
                    label: "Destino",
                    key: "destino",
                    sortable: true,
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
    },
    created() {
        this.repositories = {
            print: this.getConectaSusRepository('transportePaciente.reimpressaoProtocolo')
        }
    },
    mounted() {
        this.load()
    },
    data: () => ({
        model: null,
        form: null,
        agendados: null,
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        load() {
            this.setLoading()
            this.repositories.print.index()
                .then(({data}) => {
                    this.setData(data.model, data.form)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(model, form) {
            if(model) {
                this.model = Object.assign(model)
            }
            if(form) {
                this.form = Object.assign(form)
            }
        },
        handleSearch() {
            if(this.model.prontuario || this.model.nome || this.model.nascimento) {
                this.setLoading()
                this.repositories.print.search({
                    prontuario: this.model.prontuario,
                    nome: this.model.nome,
                    nascimento: this.model.nascimento ? moment(this.model.nascimento).format('YYYY-MM-DD') : null,
                })
                    .then(({data}) => {
                        if(data) {
                            this.agendados = Object.assign(data)
                            if(this.agendados.length == 0) {
                                this.showAlert('Nenhum agendamento encontrado.', 'Atenção!')
                            }
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.showAlert('Preencha o Prontuário, Nome ou Data de nascimento para buscar.', 'Atenção!')
            }
        },
        handleClear() {
            this.model.nome = null
            this.model.prontuario = null
            this.model.nascimento = null
            this.agendados = null
        },
        handlePrint(item) {

            let agendamento = {
                pacienteNome: item.nome,
                pacienteNomeSocial: item.nomeSocial,
                dataNascimento: moment(item.dataNascimento).format('DD/MM/YYYY'),
                prontuario: item.prontuario,
                logotipo: this.form.cliente.logotipo,
                nomePrefeitura: this.form.cliente.nome,
                ramoAtividade: this.form.cliente.sistema.ramoAtividade.nome,
                mensagemProtocolo: this.form.mensagemProtocolo,
                sistemaNome: this.form.cliente.sistema.nome,
                sistemaVersao: this.form.cliente.sistema.versao,
                usuario: this.form.usuario,
                acompanhantes: item.acompanhante ? item.acompanhante : 'NÃO',
                dataSaida: moment(item.dataSaida).format('DD/MM/YYYY'),
                horarioSaida: item.horarioSaida
                    ? moment(item.horarioSaida, 'HH:mm').format('HH:mm')
                    : 'NÃO INFORMADO',
                motivo: item.motivo ? item.motivo : 'NÃO INFORMADO',
                ponto: item.pontoId
                    ? this.form.pontos.find(p => p.id === item.pontoId).descricao : 'NÃO INFORMADO',
                destino: item.destino ? item.destino : 'NÃO INFORMADO',
                veiculo: item.veiculo ? item.veiculo : 'NÃO INFORMADO',
                telefonePaciente: item.telefonePaciente ? this.formatPhoneNumbers(item.telefonePaciente) : 'NÃO INFORMADO',
                telefoneUnidadeAgendadora: item.infraestruturaTelefone ? this.formatPhoneNumbers(item.infraestruturaTelefone) : 'NÃO INFORMADO',
                observacao: item.observacao ? item.observacao : null,
            }
            this.print().agendar(agendamento)
        },
        formatPhoneNumbers(numbers) {
            if(!numbers) return
            let formatedNumbers = []
            numbers.split(', ').forEach(number => {
                if(number.length == 10) {
                    formatedNumbers.push(`(${number.slice(0,2)}) ${number.slice(2,6)}-${number.slice(6,10)}`)
                }
                if(number.length == 11) {
                    formatedNumbers.push(`(${number.slice(0,2)}) ${number.slice(2,7)}-${number.slice(7,11)}`)
                }
            })
            return formatedNumbers.join(', ')
        },
    },
    mixins: [ error, repository, object, data, printTransportePacienteAgendar ],
}
</script>